import request from '@/utils/request'

export function listWithdrawOrders(params) {
  return request({
    url: '/admin/withdraw-orders',
    method: 'get',
    params
  })
}

export function approveWithdrawOrder(id) {
  return request({
    url: `/admin/withdraw-orders/${id}/approve`,
    method: 'put',
    data: {}
  })
}

export function rejectWithdrawOrder(id, reason) {
  return request({
    url: `/admin/withdraw-orders/${id}/reject`,
    method: 'put',
    data: { reason }
  })
}
